import { getClient, getBrowserName } from "../system/systemInfo";
import { APP_ID, CLIENT_VERSION, SERVER_URL } from "../system/appConfig";
import { getOrCreateUserIdentity } from "../system/userId";

export async function appDauStat(extraData = {}) {
  try {
    const identity = await getOrCreateUserIdentity();
    if (!identity) throw new Error("Missing user identity");

    const payload = {
      table: "app_dau",
      columns: {
        app_id: APP_ID,
        user_id: identity.userId,
        user_signature: identity.userSignature,
        client: getClient(),
        client_device_ts: new Date().toISOString(),
        client_version: CLIENT_VERSION,
        kingdom: getBrowserName(),
        ...extraData, //would contain phylum and metadata object
      },
    };

    const response = await fetch(`${SERVER_URL}/api/pg-insert`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error("Failed to fire visitStat:", await response.text());
    }
  } catch (err) {
    console.error("appDauStat error: ", err);
  }
}

export async function eventStat(extraData = {}) {
  try {
    const identity = await getOrCreateUserIdentity();
    if (!identity) throw new Error("Missing user identity");

    const payload = {
      table: "app_events",
      columns: {
        app_id: APP_ID,
        user_id: identity.userId,
        user_signature: identity.userSignature,
        client: getClient(),
        client_device_ts: new Date().toISOString(),
        client_version: CLIENT_VERSION,
        ...extraData, //would contain phylum and metadata object
      },
    };

    const response = await fetch(`${SERVER_URL}/api/pg-insert`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error("Failed to fire visitStat:", await response.text());
    }
  } catch (err) {
    console.error("appDauStat error: ", err);
  }
}

// export function eventStatBeacon(extraData = {}) {
//   console.log("yo");
//   getOrCreateUserIdentity()
//     .then((identity) => {
//       if (!identity) return;

//       const payload = {
//         table: "app_events",
//         columns: {
//           app_id: APP_ID,
//           user_id: identity.userId,
//           user_signature: identity.userSignature,
//           client: getClient(),
//           client_device_ts: new Date().toISOString(),
//           client_version: CLIENT_VERSION,
//           ...extraData,
//         },
//       };

//       const blob = new Blob([JSON.stringify(payload)], {
//         type: "application/json",
//       });

//       navigator.sendBeacon(`${SERVER_URL}/api/pg-insert`, blob);
//     })
//     .catch((err) => {
//       console.error("fireStatBeacon error:", err);
//     });
// }
